import { useSelector } from "react-redux";
import { StyledLogin } from "../../styled/Login";

const LoginLayoutWrapper = ({ children }) => {
  const logo = useSelector((state) => state.logo.getLogo.data);
  return (
    <StyledLogin.Container>
      <StyledLogin.Content elevation={15}>
        <StyledLogin.Logo src={logo} alt="logo" />
        {children}
      </StyledLogin.Content>
    </StyledLogin.Container>
  )
}

export default LoginLayoutWrapper;